
import React, { forwardRef } from "react";
import { Bookmark } from ".";

// created for MUI tooltip: see https://mui.com/material-ui/react-tooltip/#custom-child-element
export const WrappedBookmark = forwardRef((props, ref) => {
    return <Bookmark {...props} buttonRef={ref} />;
});
WrappedBookmark.displayName = "WrappedBookmark";
